import { reduxType } from "../../interfaces/reducerType"
const defaultState: any = {
    data: "",
    isVisible: false,
};
function reducer(state = defaultState, { type, payload }: reduxType) {
    switch (type) {
        case "setMoviiData":
            return payload
        default:
            return state;
    }
}
export default reducer;